<template>
  <div v-if="isLoading" class="global-loading-modal">
    <div class="modal-overlay">
      <div class="modal-content">
        <div class="modal-body">
          <LoadingProgress 
            :current-stage="loadingConfig.currentStage"
            :completed-stages="loadingConfig.completedStages"
            :stages="loadingConfig.stages"
            :title="loadingConfig.title"
            :subtitle="loadingConfig.subtitle"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingProgress from './LoadingProgress.vue';
import { useGlobalLoading } from '../composables/useGlobalLoading';

export default {
  name: 'GlobalLoadingModal',
  components: {
    LoadingProgress
  },
  setup() {
    const { isLoading, loadingConfig } = useGlobalLoading();
    
    return {
      isLoading,
      loadingConfig
    };
  }
}
</script>

<style scoped>
.global-loading-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.modal-content {
  background: var(--light-card);
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  border: 1px solid var(--light-border);
}

.modal-body {
  padding: 2rem;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .modal-overlay {
    padding: 0.5rem;
  }
  
  .modal-content {
    max-width: 100%;
    border-radius: 12px;
  }
  
  .modal-body {
    padding: 1.5rem;
  }
}

/* Dark mode support */
:global([data-theme]) .modal-overlay {
  background: rgba(0, 0, 0, 0.8);
}

:global([data-theme]) .modal-content {
  background: var(--light-card);
  border-color: var(--light-border);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
}
</style>